// src/constants/routeAccess.js

/**
 * Route access definitions untuk role-based navigation
 * Digunakan di routes.js dan DashboardLayout.vue
 */

// Route yang bisa diakses oleh kedua role (member dan partner)
export const SHARED_ROUTES = [
  "/qr-transaction",
  "/qr-details",
  "/transaction-info",
  "/change-password",
  "/system-configuration",
  "/cs",
  "/faq",
  "/logout",
  "/account", // BOTH member and partner can access
];

// Route yang hanya bisa diakses oleh member (tidak bisa diakses partner)
export const MEMBER_ONLY_ROUTES = [
  "/scan-qr",
  "/qr-choose-card",
  "/edit-profile",
  "/deposit",
  "/choose-card",
  "/deposit-method",
  "/digital-assets",
  "/alipay",
  "/wechatpay",
  "/change-atm-pin",
  "/card-management",
  "/order-card",
  "/fill-in-details",
  "/payment-method",
  "/application-fee",
  "/transfer",
  "/transfer-choose-card",
  "/transfer-method",
  "/transfer-type",
  "/TT-same-name",
  "/TT-third-party",
  "/cc",
  "/summary",
  "/summarycc",
  "/transfer-details",
  "/deposit-details",
  "/deposit-report",
  "/transfer-report",
  "/transaction",
  "/kyc",
  "/suspend",
  // Account opening routes
  "/choose-type",
  "/international-company-information",
  "/international-business-address",
  "/international-registration-address",
  "/international-director-information",
  "/international-beneficiary-information",
  "/hongkong-company-information",
  "/hongkong-registered-address",
  "/hongkong-director-information",
  "/hongkong-beneficiary-information",
  "/domestic-company-information",
  "/domestic-legal-information",
  "/domestic-registered-address",
  "/domestic-beneficiary-information",
];

// Route yang hanya bisa diakses oleh partner (tidak bisa diakses member)
export const PARTNER_ONLY_ROUTES = [
  "/wallet-report",
  "/qr-scan",
  "/withdrawal",
  "/withdrawal-report",
  "/qr-transaction-report",
  "/withdrawal-topayment-type",
  "/withdrawal-topay-application-samename",
  "/withdrawal-topay-application-thirdparty",
  "/withdrawal-va",
  "/withdrawal-tocard",
  "/withdrawal-topayment",
  "/withdrawal-method",
  "/withdrawal-tocard-application",
  "/withdrawal-topay-application",
];

// Route yang diizinkan untuk partner (gabungan shared + partner-only)
export const PARTNER_ALLOWED_ROUTES = [
  ...SHARED_ROUTES,
  ...PARTNER_ONLY_ROUTES,
];

// Utility functions untuk route checking
export const isSharedRoute = (path) => {
  return SHARED_ROUTES.some(
    (route) => path === route || path.startsWith(route + "/")
  );
};

export const isMemberOnlyRoute = (path) => {
  return MEMBER_ONLY_ROUTES.some(
    (route) => path === route || path.startsWith(route + "/")
  );
};

export const isPartnerOnlyRoute = (path) => {
  return PARTNER_ONLY_ROUTES.some(
    (route) => path === route || path.startsWith(route + "/")
  );
};

export const isPartnerAllowedRoute = (path) => {
  return PARTNER_ALLOWED_ROUTES.some(
    (route) => path === route || path.startsWith(route + "/")
  );
};

// Helper untuk mendapatkan redirect path berdasarkan role
export const getDefaultRedirectPath = (role) => {
  return role === "partner" ? "/account" : "/transaction";
};

/**
 * Menentukan apakah route change memerlukan redirect
 * @param {string} currentPath - Path saat ini
 * @param {string} newRole - Role baru (member/partner)
 * @param {string} oldRole - Role lama (member/partner)
 * @returns {object} - {redirect: boolean, path: string}
 */
export const shouldRedirectOnRoleChange = (currentPath, newRole, oldRole) => {
  if (newRole === "partner") {
    // Jika switch ke partner dan di route yang tidak bisa diakses partner
    if (isMemberOnlyRoute(currentPath)) {
      return { redirect: true, path: getDefaultRedirectPath("partner") };
    }
  } else if (newRole === "member") {
    // Jika switch ke member dan di route yang tidak bisa diakses member
    if (isPartnerOnlyRoute(currentPath)) {
      return { redirect: true, path: getDefaultRedirectPath("member") };
    }

    // Jika switch ke member dari account page partner
    if (currentPath === "/account" && oldRole === "partner") {
      return { redirect: true, path: getDefaultRedirectPath("member") };
    }
  }

  // Tidak perlu redirect
  return { redirect: false };
};
